export default "__VITE_PUBLIC_ASSET__0009d9f7__"